//#region src/errors/failed-dependency.ts
var e = class extends Error {
	constructor(e) {
		super(e), this.name = this.constructor.name;
	}
};
//#endregion
export { e as FailedDependency };
